<template>
    <div class="pb-2">
        <b-row class="px-2 d-flex align-items-center">
            <b-col md="4">
                <h3>Organization Info</h3>
            </b-col>
            <b-col md="8">
                <b-button
                    v-b-modal.organizationEdit
                    class="main-navigation-button"
                    variant="white"
                    btn-color="primary1"
                >
                    <v-avatar size="25">
                        <img src="img/Edit.png" />
                    </v-avatar>
                </b-button>
            </b-col>
            <b-modal
                id="organizationEdit"
                title="Organization Details"
                header-class="header-nipige-class"
                size="lg"
                centered
                hide-footer
            >
                <sorganizationmodel
                    :orgoListData="orgoAccessLists"
                    @place_changed="setPlace"
                    class="mt-3 ml-1"
                >
                    <template v-slot:footer-button="data">
                        <b-row class="mt-3">
                            <b-col md="8"></b-col>
                            <b-col md="4">
                                <b-button
                                    class="btn btn-block"
                                    btn-color="primary"
                                    @click="OrgToNext(data.data)"
                                >
                                    Update</b-button
                                >
                            </b-col>
                        </b-row>
                    </template>
                </sorganizationmodel>
            </b-modal>
        </b-row>
        <b-row class="px-2 mt-1">
            <b-col>
                <b-row>
                    <b-col md="6">
                        <p class="left-text">Organization Name :</p>
                    </b-col>
                    <b-col md="6">
                        <p class="right-text">
                            {{
                                orgoData &&
                                orgoData.organization &&
                                orgoData.organization.name
                            }}
                        </p>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-row>
                    <b-col class="line" md="6">
                        <p class="left-text">Access Level :</p>
                    </b-col>
                    <b-col md="6">
                        <p class="right-text">
                            {{ orgoAccessLevelName }}
                        </p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="m-2 line-bottom"></b-row>
        <b-row class="px-2">
            <b-col>
                <b-row>
                    <b-col md="6">
                        <p class="left-text">FSSCI No :</p>
                    </b-col>
                    <b-col md="6">
                        <p class="right-text">
                            {{
                                orgoData &&
                                orgoData.organization &&
                                orgoData.organization.fssciNo
                            }}
                        </p>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-row>
                    <b-col class="line" md="6">
                        <p class="left-text">GST No. :</p>
                    </b-col>
                    <b-col md="6">
                        <p class="right-text">
                            {{
                                orgoData &&
                                orgoData.organization &&
                                orgoData.organization.gstNo
                            }}
                        </p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="m-2 line-bottom"></b-row>
        <b-row class="px-2">
            <b-col>
                <b-row>
                    <b-col md="6">
                        <p class="left-text">Registration No :</p>
                    </b-col>
                    <b-col md="6">
                        <p class="right-text">
                            {{
                                orgoData &&
                                orgoData.organization &&
                                orgoData.organization.registrationNo
                            }}
                        </p>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-row>
                    <b-col class="line" md="6">
                        <p class="left-text">Location :</p>
                    </b-col>
                    <b-col md="6">
                        <p class="right-text">
                            {{
                                orgoData &&
                                orgoData.office &&
                                orgoData.office.address &&
                                orgoData.office.address.city
                            }},
                            {{
                                orgoData &&
                                orgoData.office &&
                                orgoData.office.address &&
                                orgoData.office.address.state
                            }}
                        </p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from "@/components";
import { getReverseGeoCode } from "@/services/geocode";
import sorganizationmodel from "@/components/Partner/PartnerEdit/OrganizationStepper";
import sofficemodel from "@/components/Partner/PartnerEdit/OfficeStepper";
import { mapGetters } from "vuex";
export default {
    name: "orgView",
    props: ["orgoData"],
    data() {
        return {
            dialog: false,
            orgLocation: null,
            position: {
                lat: 0,
                lng: 0,
            },
            orgoAccessLists: null,
        };
    },
    components: {
        AppHeaderDropdown,
        sorganizationmodel,
        sofficemodel,
    },
    computed: {
        ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
        orgoAccessLevelName() {
            if (this.orgoData?.authorization?.orgAccess) {
                return this.orgoData.authorization.orgAccess.orgAccessLevel;
            } else {
                return "";
            }
        },
        officeData() {
            if (this.orgoData.office) {
                return this.orgoData.office.officeName;
            } else {
                return null;
            }
        },
        orgoAccessListAll() {
            if (
                this.orgoData.authorization.orgAccess &
                this.orgoData.authorization.orgAccessList
            ) {
                return this.orgoData.authorization.orgAccess.orgAccessList;
            } else {
                return "";
            }
        },
        orgAccessListOptions() {
            let data = this.$store.getters["partner/GetPartnerList"];
            let tenantList = [];
            try {
                if (Array.isArray(data) && data.length > 0) {
                    data.map((obj) => {
                        if (obj.category === "OFFICE") {
                            let arrayObj = {
                                _id: obj._id,
                                userName: obj.authentication.userName,
                                email: obj.authentication.email,
                                phone: obj.authentication.phone,
                                password: "",
                                ...obj,
                            };
                            tenantList.push(arrayObj);
                        }
                    });
                    return tenantList;
                } else {
                    return [];
                }
            } catch (err) {}
        },
    },
    methods: {
        async OrgToNext(data) {
            if (data.logo == "") {
                data.logo = this.orgoData.organization.logo.url;
            } else {
                data.logo = data.logo;
            }
            let authorization = {};
            let orgaccess = [];
            let authData = {
                email: this.partnerAllData?.authentication?.email,
                phone: this.partnerAllData?.authentication?.phone,
                userName: this.partnerAllData?.authentication?.userName,
            };
            if (
                Array.isArray(data.orgAccessList) &&
                data.orgAccessList.length > 0
            ) {
                data.orgAccessList.map((obj) => {
                    orgaccess.push(obj._id);
                });
            }
            authorization.orgAccess = {
                orgAccessLevel: data.orgAccessLevel?.value,
                orgAccessList: orgaccess,
            };
            delete data.orgAccessLevel;
            delete data.orgAccessList;
            try {
                let payload = {
                    id: this.partnerAllData?._id,
                    data: {
                        authorization,
                        organization: data,
                    },
                };
                payload.data.category = this.partnerAllData?.category;
                payload.data.authentication = authData;
                await this.$store.dispatch("partner/updatePartner", payload);
                this.$swal({
                    title: "Success",
                    text: "Partner Edited successfully!",
                    type: "success",
                });
                this.$emit("reload-partner", this.partnerAllData._id);
                this.$root.$emit(
                    "bv::hide::modal",
                    "organizationEdit",
                    "#btnShow"
                );
            } catch (e) {
                this.$swal({
                    title: "Error",
                    text: "Could not Edited partner",
                    type: "error",
                });
            }
        },
        async OfficeToNext(data) {
            let payload = {
                id: this.partnerAllData._id,
                data: {
                    office: data,
                    category: data.category.value,
                },
            };
            this.$store
                .dispatch("partner/updatePartner", payload)
                .then((result) => {
                    this.$swal({
                        title: "Success",
                        text: "Partner Edited successfully!",
                        type: "success",
                    });
                    this.$root.$emit(
                        "bv::hide::modal",
                        "officeEdit",
                        "#btnShow"
                    );
                })
                .catch((error) => {
                    this.$swal({
                        title: "Error",
                        text: "Could not Edited partner",
                        type: "error",
                    });
                });
        },
        async setPlace(p) {
            let place = await p;
            let position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.position = position;
        },
        isUrlValid(userInput) {
            try {
                var res = userInput.match(
                    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
                );
                if (res == null) return false;
                else return true;
            } catch (err) {}
        },
    },
    async created() {
        if (!this.$store.getters["partner/GetPartnerList"].length) {
            this.$store.dispatch("partner/fetchPartnersList");
        }
        let orgoAccessListlNames = [];
        if (
            Array.isArray(
                this.orgoData?.authorization?.orgAccess?.orgAccessList
            ) &&
            this.orgoData?.authorization?.orgAccess?.orgAccessList?.length > 0
        ) {
            this.orgoData.authorization.orgAccess.orgAccessList.forEach(
                (element) => {
                    let singleorgoAccessListData =
                        this.orgAccessListOptions.filter(
                            (obj) => obj._id == element
                        );
                    orgoAccessListlNames.push(singleorgoAccessListData);
                }
            );
        }
        this.orgoAccessLists = orgoAccessListlNames;
        try {
            const data = await getReverseGeoCode(
                `${this.orgoData.office.address.street1},${this.orgoData.office.address.city},${this.orgoData.office.address.state},${this.orgoData.office.address.country}`
            );
            if (data.data.status === "OK") {
                this.orgLocation = data.data.results[0].formatted_address;
            }
        } catch (error) {}
    },
};
</script>
<style scoped>
.text-style {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.15px;
    color: rgba(143, 143, 143, 0.87);
}
.left-text {
    margin-bottom: 0px;
    font-size: 16px;
    font-weight: 500;
    color: #58585b;
}
.right-text {
    margin-bottom: 0px;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}
.list-style {
    list-style-type: none;
    text-align: left;
}
.list-style1 {
    list-style-type: none;
    text-align: left;
    display: inline;
}
[btn-color="primary1"] {
    outline: none !important;
    border-radius: 50%;
    height: 39px;
    width: 39px;
    margin-left: 10px;
    padding: 0;
}
[btn-special="primary1"] {
    border-radius: 50%;
}
.header-style {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
}
@media (max-width: 767px) {
    .my-content {
        display: none;
    }
}
@media (min-width: 767px) {
    .mobile-responsive {
        display: none;
    }
}
@media (max-width: 767px) {
    .edit_button {
        margin-top: -30px;
        margin-right: -12px;
    }
}
.line {
    border-left: 1px dashed #c2c2c2;
}
.line-bottom {
    border-bottom: 1px dashed #c2c2c2;
}
</style>
